"use client";
import posthog from "posthog-js";
import type React from "react";

export { useFeatureFlagEnabled, usePostHog } from "posthog-js/react";

import { PostHogProvider as BasePostHogProvider } from "posthog-js/react";
import { isGlobalPrivacyControlEnabled } from "./utils";

if (typeof window !== "undefined" && process.env.NEXT_PUBLIC_POSTHOG_API_KEY) {
  posthog.init(process.env.NEXT_PUBLIC_POSTHOG_API_KEY, {
    debug: false,
    api_host: process.env.NEXT_PUBLIC_POSTHOG_API_HOST,
    capture_pageview: false,
    capture_pageleave: true,
    disable_session_recording: true,
    enable_heatmaps: false,
    persistence: "cookie",
    autocapture: false,
    opt_out_capturing_by_default: isGlobalPrivacyControlEnabled(),
    cross_subdomain_cookie: true,
  });
}

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  return <BasePostHogProvider client={posthog}>{children}</BasePostHogProvider>;
}

export { posthog };
